import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import {Stack} from "@mui/material";

// Register necessary components for Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarchartStatus = ({ companies }) => {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [],
    });

    useEffect(() => {
        if (!Array.isArray(companies) || companies.length === 0) {
            setChartData({
                labels: [],
                datasets: [],
            });
            return;
        }

        // Step 1: Get unique statusx values
        const StatusTypes = [...new Set(companies.map(company => company.Statusx))];

        // Step 2: Group companies by Deadline and count per Status type
        const groupedData = companies.reduce((acc, company) => {
            const { Deadline, Statusx } = company;
            if (!acc[Deadline]) {
                acc[Deadline] = {};
            }
            if (!acc[Deadline][Statusx]) {
                acc[Deadline][Statusx] = 0;
            }
            acc[Deadline][Statusx] += 1;
            return acc;
        }, {});

        // Step 3: Prepare labels (dates) and datasets dynamically
        const labels = Object.keys(groupedData).sort(); // Sort labels by date
        const datasets = StatusTypes.map(statusType => ({
            label: statusType,
            data: labels.map(label => groupedData[label][statusType] || 0), // Fill in data or 0 if none
            backgroundColor: getRandomColor(), // Helper function to generate random color
            borderColor: getRandomColor(),
            borderWidth: 1,
        }));

        // Step 4: Set the chart data
        setChartData({
            labels: labels,
            datasets: datasets,
        });
    }, [companies]);

    // Helper function to generate random color for each dataset
    const getRandomColor = () => {
        const r = Math.floor(Math.random() * 255);
        const g = Math.floor(Math.random() * 255);
        const b = Math.floor(Math.random() * 255);
        return `rgba(${r}, ${g}, ${b}, 0.6)`;
    };

    return (
        <div style={{ width: '80%', margin: '0 auto' }}>
            <Stack   justifyContent="space-between" alignItems="center" spacing={1} >
            <h2>STATUS</h2>
           
            <Bar
                data={chartData}
                options={{
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: 'Count Status by Deadlines',
                        },
                    },
                    scales: {
                        x: {
                            title: {
                                display: true,
                                text: 'Deadline Date',
                            },
                        },
                        y: {
                            title: {
                                display: true,
                                text: 'No. of Status',
                            },
                            beginAtZero: true,
                        },
                    },
                }}
            />
             </Stack>
        </div>
    );
};

export default BarchartStatus;